import React from "react";

const Content = () => {
  return (
    <div>
      <div className="container-fluid content-container">
        {/* <div className="col"> */}
        <div className="col socio-impact">
          <h1 className="socio-impact-heading">
            Social Impact Powered By{" "}
            <span className="socio-impact-you">YOU</span>.
          </h1>
          <p className="socio-impact-paragraph">
            With evolving technology and best practices, change makers across
            the world are developing innovative solutions to solve world's
            toughest social problems. Yet these efforts need complementary
            support as NGOs lack awareness and access to these innovations. Our
            aim is to connect NGOs with these social innovations while raising
            exact funds needed to deploy projects on site. Mark your <span className='highlight'>LEGACY</span> and
            join us in driving a radical change in the society.
          </p>
        </div>

        <div className="row philanthropy philanthropy-bg">
          <div className="col-sm-12 col-md-6 col-lg-6 philanthropy-col">
            <div className="philanthropy-content">
              <h1 className="philanthropy-heading">
                A New Way Of <span className="highlight">Philanthropy</span>
              </h1>
              <p className="philanthropy-text">
                LetsEndorse Giving Circuit is an inclusive guild of passionate
                philanthropists who regularly endorse strategic &amp;
                solution-centric projects to solve social issues at scale.
              </p>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6 philanthropy-img-col">
            <img
              src="/images/philanthropy.svg"
              alt=""
              className="philanthropy-img img-fluid"
            />
          </div>
        </div>

        <div className="row  build">
          <div className="col-sm-12 col-md-6 col-lg-6 build-img-col">
            <img
              src="/images/build.png"
              alt=""
              className="build-img img-fluid"
            />
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6 build-col">
            <div className="build-content ">
              <h1 className="build-heading">
                Global <span className="highlight">Solutions </span>
                for Local <span className="highlight">Problems</span>
              </h1>
              <p className="build-text">
                Proven social innovations across United Nations Sustainable
                Development goals enables building wide and deep philanthropic
                portfolio to create impact in local community.
              </p>
            </div>
          </div>
        </div>

        <div className="row  solution">
          <div className="col-sm-12 col-md-6 col-lg-6 solution-col">
            <div className="solution-content">
              <h1 className="solution-heading">
                <span className="highlight">Transparent </span>
                Impact Assessment
              </h1>
              <p className="solution-text">
                Deployment of social innovations enables objective and tangible
                impact measurement replicating success at multiple sites.Open
                on-site visits and reviews by members ensure transparency.
              </p>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6 solution-img-col">
            <img
              src="/images/solution.png"
              alt=""
              className="solution-img img-fluid"
            />
          </div>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default Content;



// WEBPACK FOOTER //
// ./src/Components/LandingPage/Content.js